define('GameDayCore/GDModel/ValueObjects/Resources/StaticResources',['require','exports','module','../ValueObjectFactory','../../../GDControl/GameModelLocator/GameModelLocator','jquery','extant/extant','ensureArray/ensureArray'],function(require,exports,module) {
    var VO = require('../ValueObjectFactory'),
        GameModelLocator = require("../../../GDControl/GameModelLocator/GameModelLocator"),
        $ = require("jquery"),
        extant = require("extant/extant"),
        ensureArray = require('ensureArray/ensureArray');

    VO.create(StaticResources);

    function StaticResources ($data) {
        var vo = VO.ensureVO(this, StaticResources),
            data = $data,
            display_config,
            theVO,
            _areHighlightsEnabled,
            _jingleMappings = [],
            _shareablePlaysEnabled = false,
            _sharingPreviewGraphic,
            _gdConfigObjectArray,
            _skinConfigObjectArray;


        //init display config, masking the default properties with
        //partner-specific props when available
        if (typeof data.partner_display_config !== undefined){
            display_config = $.extend( true, data.display_config, data.partner_display_config);
        } else {
            display_config = data.display_config;
        }

        theVO = display_config.GamedayDisplay;
        //DisplayConfigModel.init(display_config.GamedayDisplay);

        _gdConfigObjectArray = data.gd_config.gdconfig.skin;
        _skinConfigObjectArray = data.skin_config.skin_config.skins.skin;

        //_dockNavItems = theVO.htmlDockNavItems.dockNavItem;
        if (extant(theVO.jingleMappings))
            _jingleMappings = ensureArray(theVO.jingleMappings.jingle);

        /*
         //determine if highlights are enabled in the UI
         for(var i=0 , l=_dockNavItems.length ; i<l ; i++) {
         if(_dockNavItems[i].id === "video") {
         _areHighlightsEnabled = (_dockNavItems[i].enabled.toString() === "true");
         }
         }

         if (extant(theVO.shareablePlays)) {
         _shareablePlaysEnabled = theVO.shareablePlays.enabled.toString() === "true";
         // TODO: put messages / sharing icon gfx and titling display_config file
         }
         */
        //add resource bundles to the resource Manager
        //ResourceManager.addResourceBundle(data.en_GDApp.bundle);
        //ResourceManager.addResourceBundle(data.es_GDApp.bundle);
        //ScenesManager.init(theVO);
        function jingleMappingDateToMillis(dateStr){
            var year 	= parseInt(dateStr.substring(0,4)),
                month 	= parseInt(dateStr.substring(4,6))-1,
                day 	= parseInt(dateStr.substring(6,8));
            return new Date().setFullYear(year,month,day);
        }

        $.extend(vo, {
            scenes: [],
            gdConfigObjectArray: _gdConfigObjectArray,
            skinConfigObjectArray: _skinConfigObjectArray,
            skin: null,
            /*
             getFieldGraphicUrl: function(venueID){
             return theVO.assets.fields.replace(/\$\{id\}/g,venueID);
             },
             */
            getMugshotUrl: function(playerID, retina) {
                var pathto = theVO.assets.mugshots.replace(/\$\{id\}/g,playerID).replace(/\$\{sportcode\}/g,GameModelLocator.getCurrentGame().gid.home_sport_code);
                if (retina === true) { pathto = pathto.substr(0, pathto.lastIndexOf(".")) + "@2x" + pathto.substr(pathto.lastIndexOf(".")) }
                return pathto;
            },
            /*
             getDockNavItems: function() {
             return _dockNavItems;
             },
             */
            getJingleMapping: function(eventName){
                var jingle,
                    i,
                    retVal = eventName,
                    startDateMillis,
                    endDateMillis,
                    currentDateMillis = new Date();

                for (i in _jingleMappings){

                    jingle = _jingleMappings[i];

                    if (jingle.event === eventName){

                        //if this has a start and end date, check whether to do the mapping
                        if (extant(jingle.start_yyyymmdd) && extant(jingle.end_yyyymmdd)){
                            //validate the formatting
                            if (jingle.start_yyyymmdd.length === 8 && jingle.end_yyyymmdd.length === 8 && !isNaN(jingle.start_yyyymmdd) && !isNaN(jingle.end_yyyymmdd)){
                                startDateMillis = jingleMappingDateToMillis(jingle.start_yyyymmdd);
                                endDateMillis = jingleMappingDateToMillis(jingle.end_yyyymmdd);
                                //check if the current date is in between the start and end dates
                                if (startDateMillis < currentDateMillis && currentDateMillis < endDateMillis)
                                    retVal = jingle.fileprefix;
                            }
                            //if there wasn't a start and end date, this is a straight mapping, so return the mapped value
                        } else {
                            retVal = jingle.fileprefix;
                        }
                    }
                }
                return retVal;
            },
            areHighlightsEnabled: function() {
                return _areHighlightsEnabled;
            },
            areShareablePlaysEnabled: function() {
                return _shareablePlaysEnabled;
            },
            getStadiumFileName: function($venueID){
                var i, teamObj;
                for (i=0; i < theVO.graphics.team.length; i++){
                    teamObj = theVO.graphics.team[i];
                    if (teamObj.venue_id === $venueID && teamObj.hasVenue === "Y"){
                        return $venueID;
                    }
                }
                return theVO.graphics.default_venue;
            },
            getBatterFileTeamID: function($teamID){
                var i, teamObj;
                for (i=0; i < theVO.graphics.team.length; i++){
                    teamObj = theVO.graphics.team[i];
                    if (teamObj.team_id === $teamID && teamObj.hasBatter === "Y"){
                        return $teamID;
                    }
                }
                return theVO.graphics.default_batter;
            },
            /* determineSkin: function(){

             var gameModel = GDAppGameModelLocator.getCurrentGameModel(),
             home_sportcode = gameModel.gameIdVO.home_sportcode,
             gameFileVO = gameModel.getGameFileVO(),
             skin_node,
             i,
             custom_skin,
             league_matched,
             gametype_matched,
             skin_id = "000";

             //loop through the gd config object array and look for
             //one this has the league and game type of this game
             for (i = 0; i < this.gdConfigObjectArray.length; i++) {
             skin_node = this.gdConfigObjectArray[i];
             custom_skin = league_matched = gametype_matched = false; //reset flags
             if(skin_node.sport_code == home_sportcode) {

             //check league type
             if((skin_node.league == "*") || (skin_node.league == "")) {
             league_matched = true;
             } else if (skin_node.league.toLowerCase() == gameFileVO.home.league.toLowerCase()) {
             league_matched = true;
             } else {
             league_matched = false;
             }

             //check game type
             if((skin_node.game_type == "*") || (skin_node.game_type == "")) {
             gametype_matched = true;
             } else if(skin_node.game_type.toLowerCase() == gameFileVO.type.toLowerCase()) {
             gametype_matched = true;
             } else {
             gametype_matched = false;
             }

             //if both are found, use this skin
             if(!!league_matched && !!gametype_matched) {
             //trace("custom skin found: "+skin_node.id);
             custom_skin = true;
             skin_id = skin_node.id;
             break;
             }
             }
             }

             $.log("Skin ID = "+skin_id);
             //find the matching skin object from the skin config array
             //and assign it to the this.skin var
             for (i = 0; i < this.skinConfigObjectArray.length; i++) {
             if (this.skinConfigObjectArray[i].id){
             this.skin = this.skinConfigObjectArray[i];
             break;
             }

             }
             },

             getTwitterOverrideAccount: function() {
             return theVO.twitter.insiderAccountOverride;
             },
             */

            getAuditude: function() {
                return (extant(theVO, "auditude")) ? theVO.auditude: false;
            },

            getMidInningGamesXmlUrl: (function (){
                return (extant(theVO.mid_inning_game_config_url)) ? theVO.mid_inning_game_config_url.content : null;
            })(),

            midInningGamesEnabled: (function (){
                return (extant(theVO.mid_inning_game_config_url)) ? (theVO.mid_inning_game_config_url.enabled === "true") : false;
            })(),

            videoFormat: (function() {
                return "videocore";
            })(),

            rawData: theVO // exposing this for stopgap measures for stuff we haven't finished yet.
        });
    }

    return StaticResources;
});
